import React from 'react';
import { formatSignedCount } from '../../utils/numberFormatter';
import { formatShortDate } from '../../utils/dateFormatter';
import { TEXT, UNIT_LABELS, itemNames } from '../../config/stockLabels';

/**
 * One item as a shelf label — photo, name, the count in large figures and its unit, and a coloured edge
 * for its state. The state is the server's (`flags`), never worked out here: below zero reads «العدد غير
 * صحيح» (D10), at or under the low-stock level «منخفض», otherwise «متوفر».
 */
export const tileState = (item) => {
  if (item.archived) return 'archived';
  if (item.flags?.negative) return 'negative';
  if (item.flags?.low) return 'low';
  return 'ok';
};

const STATE_TEXT = {
  ok: TEXT.stateOk,
  low: TEXT.stateLow,
  negative: TEXT.stateNegative,
  archived: TEXT.stateArchived,
};

const StockItemTile = ({ item, onOpen }) => {
  const state = tileState(item);
  const { primary, secondary } = itemNames(item);
  const overdue = Boolean(item.flags?.recountOverdue);

  return (
    <button type="button" className={`stk-tile stk-tile--${state}`} onClick={() => onOpen(item)}>
      <span className="stk-tile__photo" aria-hidden="true">
        {item.photoUrl
          ? <img src={item.photoUrl} alt="" loading="lazy" />
          : <i className="bi bi-box-seam"></i>}
      </span>

      <span className="stk-tile__names">
        <span className="stk-tile__name">{primary}</span>
        <span className="stk-tile__name-en" dir="ltr">{secondary}</span>
      </span>

      <span className="stk-tile__count">
        <bdi dir="ltr" className="stk-tile__num">{formatSignedCount(item.quantity)}</bdi>
        <span className="stk-tile__unit">{UNIT_LABELS[item.unit] || item.unit}</span>
      </span>

      <span className="stk-tile__foot">
        <span className="stk-chip">{STATE_TEXT[state]}</span>
        <span className={overdue ? 'stk-tile__when stk-tile__when--late' : 'stk-tile__when'}>
          {overdue && <i className="bi bi-clock-history" aria-hidden="true"></i>}
          {item.lastCountedAt ? `${TEXT.lastCounted}: ${formatShortDate(item.lastCountedAt)}` : TEXT.neverCounted}
        </span>
      </span>
    </button>
  );
};

export default StockItemTile;
